import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './NavBar.css';

export function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [resourcesOpen, setResourcesOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src="/logo.svg" alt="Survey Sherpa" className="nav-logo" />
          <span className="nav-product-name">Outpost</span>
        </div>
        <div className="navbar-user">
          <span className="nav-username">{user?.name}</span>
          <Link to="/" className="nav-link">Dashboard</Link>
          <Link to="/suppliers" className="nav-link">Suppliers</Link>
          <div className="nav-dropdown" onMouseEnter={() => setResourcesOpen(true)} onMouseLeave={() => setResourcesOpen(false)}>
            <button className="nav-link nav-dropdown-btn">Resources ▾</button>
            {resourcesOpen && (
              <div className="nav-dropdown-menu">
                <a href="https://www.surveysherpa.com/supplier-partners/" target="_blank" rel="noopener noreferrer" className="nav-dropdown-item">
                  Supplier Partner Info
                </a>
                <a href="https://www.surveysherpa.com/sample-supplier-onboarding/" target="_blank" rel="noopener noreferrer" className="nav-dropdown-item">
                  Onboarding Form
                </a>
              </div>
            )}
          </div>
          <Link to="/settings" className="nav-link">Settings</Link>
          <button onClick={logout} className="logout-button">Logout</button>
        </div>
      </nav>
      <div className="nav-footer-spacer" />
    </>
  );
}

export function PageFooter() {
  return (
    <footer className="page-footer">
      Outpost by Survey Sherpa &middot; v1.0
    </footer>
  );
}
